var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXCircleError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "x-circle-error",
    d: "M18.375,3.375a15,15,0,1,0,15,15A15,15,0,0,0,18.375,3.375Zm3.8,20.43-3.8-3.8-3.8,3.8a1.152,1.152,0,1,1-1.63-1.63l3.8-3.8-3.8-3.8a1.152,1.152,0,0,1,1.63-1.63l3.8,3.8,3.8-3.8a1.152,1.152,0,0,1,1.63,1.63l-3.8,3.8,3.8,3.8a1.158,1.158,0,0,1,0,1.63A1.145,1.145,0,0,1,22.175,23.805Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#fb797b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircleError);
export default __webpack_public_path__ + "static/media/x-circle-error.fd387900cb3cb70c95faa8ecdd562e76.svg";
export { ForwardRef as ReactComponent };